/**
 * ObjectiveCorrectnessView — Parsed Feedback view for runs whose prompt
 * declares `outputSchemaType: 'ObjectiveCorrectnessV1'`. Admin-debug wrapper
 * around the canonical `ObjectiveCorrectnessAnalysis` schema view. Adds the
 * admin-only cross-check block (student answer, correct answer, confidence).
 */
import type { Feedback } from '@padcanvas/shared';
import { ObjectiveCorrectnessAnalysis } from '../solution-analysis';
import { AdminCrossCheckFields, type SolutionLearningMoment, type RejectMomentHandler } from './AdminCrossCheckFields';

interface Props {
    feedback: Feedback;
    question?: { correctAnswer?: string };
    learningMoments?: SolutionLearningMoment[];
    onRejectMoment?: RejectMomentHandler;
}

export function ObjectiveCorrectnessView({ feedback, question, learningMoments, onRejectMoment }: Props) {
    return (
        <div className="feedback-content">
            <ObjectiveCorrectnessAnalysis feedback={feedback} />
            <AdminCrossCheckFields feedback={feedback} question={question} learningMoments={learningMoments} onRejectMoment={onRejectMoment} />
        </div>
    );
}
